import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Rota legacy /cliente/esqueci-senha — redireciona para o login unificado
 * onde o modal inline de "Esqueci minha senha / Primeiro acesso" agora
 * aceita CPF como chave e o e-mail é opcional.
 */
const ForgotPassword = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/cliente/login?forgot=1', { replace: true });
  }, [navigate]);
  return null;
};

export default ForgotPassword;
